export enum LightsOutObjectType {
    Electricity = "electricity",
    Light = "light",
    Fridge = "refrigerator",
    Water = "water",
    EasterEgg = "easteregg",
}
